import type { AppSettingsType, SettingsParamsType } from '@econtractor/types';
import { normalizeSettingsParams } from 'components/Settings/MainSettings/model/defaults';

let cachedSettings: Pick<AppSettingsType, 'global'> | null = null;

/** Keep latest app settings for non-React helpers (e.g. VAT calc). */
export const setSettingsParamsCache = (
    settings?: Pick<AppSettingsType, 'global'> | null,
): void => {
    cachedSettings = settings ?? null;
};

export const hasSettingsParamsCache = (): boolean => cachedSettings != null;

export const getCachedSettingsParams = (): SettingsParamsType =>
    normalizeSettingsParams(cachedSettings?.global?.params);
